import React from 'react';

const StatusToggle = ({ isHidden, onChange, disabled = false }) => {
    const hidden = isHidden === true;
    const active = !hidden;

    const handleClick = () => {
        if (disabled) return;
        onChange(!hidden);
    };

    return (
        <label
            onClick={handleClick}
            title={active ? 'Shown — click to hide' : 'Hidden — click to show'}
            style={{
                position: 'relative',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.6 : 1,
                userSelect: 'none',
            }}
        >
            <span
                style={{
                    position: 'relative',
                    display: 'inline-block',
                    width: 42,
                    height: 22,
                    borderRadius: 22,
                    transition: 'background-color 0.2s ease',
                    backgroundColor: active ? '#F05423' : '#c4c4c4',
                    flexShrink: 0,
                }}
            >
                <span
                    style={{
                        position: 'absolute',
                        top: 3,
                        left: active ? 23 : 3,
                        width: 16,
                        height: 16,
                        borderRadius: '50%',
                        backgroundColor: '#fff',
                        transition: 'left 0.2s ease',
                    }}
                />
            </span>
            <span
                style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: active ? '#F05423' : '#8A8A8A',
                }}
            >
                {active ? 'Show' : 'Hide'}
            </span>
        </label>
    );
};

export default StatusToggle;
